import type { TenantConfig } from '@/types/TenantConfig'

export const mofe: TenantConfig = {
  logo: 'assets/mofe/static/logo.svg',
  teaserImageSize: {
    width: 320,
    height: 240,
  },
  themeOptions: {
    primaryColor: '#03052c',
    secondaryColor: '#201550',
    headerBackground: 'white',
    cartHeaderBackgroundColor: '#ffffff',
    cartHeaderTextColor: '#000000',
    footerBackgroundColor: '#03052c',
    footerTextColor: 'white',
    logoHeight: '35px',
    headerBottomBorder: '1px solid #03052c',
  },
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet: 'https://use.typekit.net/tsu4pxd.css',
    },
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/mofe/static/completed.jpeg',
      },
      completedContentOffset: {
        desktop: '-200px',
        mobile: '-150px',
      },
    },
  },
}
